import * as React from 'react';
import { PreviewBody, PreviewBodyProps } from './PreviewLabelCallout';
import { getStringTable } from '../../utilities/localizationUtilities';
import { IdentityType } from '@fluidx/office-fluid-types';
import { Locale } from '@fluidx/utilities';

export async function getPreviewBodyWithStrings(locale: Locale, identityType: IdentityType) {
  const stringTable = await getStringTable(locale);

  return {
    default: (
      props: Omit<
        PreviewBodyProps,
        | 'title'
        | 'firstPara'
        | 'secondPara'
        | 'gettingStartedText'
        | 'termsOfUseText'
        | 'privacyAndCookiesText'
        | 'thirdPartyNoticesText'
        | 'buttonLabel'
        | 'linkLocale'
      >
    ) => (
      <PreviewBody
        appColors={props.appColors}
        title={
          identityType === 'Consumer'
            ? stringTable.previewLabelDialogTitleConsumer
            : stringTable.previewLabelDialogTitle
        }
        firstPara={
          identityType === 'Consumer'
            ? stringTable.previewLabelDialogFirstParaConsumer
            : stringTable.previewLabelDialogFirstPara
        }
        secondPara={identityType === 'Consumer' ? stringTable.previewLabelDialogSecondParaConsumer : undefined}
        gettingStartedText={
          identityType === 'Consumer' ? stringTable.previewLabelDialogGettingStartedLinkText : undefined
        }
        termsOfUseText={stringTable.previewLabelDialogTermsLinkText}
        privacyAndCookiesText={stringTable.previewLabelDialogPrivacyLinkText}
        thirdPartyNoticesText={stringTable.previewLabelDialogThirdPartyLinkText}
        buttonLabel={stringTable.previewLabelDialogConfirmButtonText}
        onPrimaryButtonClick={props.onPrimaryButtonClick}
        linksLocale={locale}
      />
    )
  };
}
